import React, { useEffect } from 'react';
import { FaMoon, FaSun } from 'react-icons/fa';

const DarkModeToggle = ({ setIsDarkMode, isDarkMode }) => {
  const toggleDarkMode = () => {
    if (!window?.DarkReader) return;

    if (isDarkMode) {
      window.DarkReader.disable();
    } else {
      window.DarkReader.enable({
        brightness: 100,
        contrast: 90,
        sepia: 10,
      });
    }
    setIsDarkMode(!isDarkMode);
  };

  useEffect(() => {
    if (!window.DarkReader) return;

    if (isDarkMode) {
      window.DarkReader.enable({
        brightness: 100,
        contrast: 90,
        sepia: 10,
      });
    } else {
      window.DarkReader.disable();
    }
  }, [isDarkMode]);

  return (
    <div
      onClick={toggleDarkMode}
      style={{
        background: 'none',
        border: 'none',
        cursor: 'pointer',
      }}
    >
      {isDarkMode ? <FaSun size={'1em'} color="#FFA500" /> : <FaMoon size={'1em'} color="#4D5B6B" />}
    </div>
  );
};

export default DarkModeToggle;
